import { useGetMemberTeamResultsByCompQuery } from '../state/api';
import MemberTeamHistory from './member-team-history';

interface MemberTeamHistoryContainerProps {
  member_id: string | undefined;
}

const MemberTeamHistoryContainer = ({ member_id }: MemberTeamHistoryContainerProps) => {
  const { data: history = [] } = useGetMemberTeamResultsByCompQuery(member_id!, {
    skip: member_id === undefined,
  });

  return <MemberTeamHistory history={history} />;
};

export default MemberTeamHistoryContainer;
